/*
 * Copyright (c) 2025. World Wide Generation Ltd
 */

import React, { useState } from 'react';
import { ConnectionDetailsPage } from './ConnectionDetailsPage';
import { DataConnections } from './DataConnections/DataConnections';

interface DataConnectionsTabProps {
  initiativeId: string;
}

export const DataConnectionsTab: React.FC<DataConnectionsTabProps> = ({ initiativeId }) => {
  const [selected, setSelected] = useState<{
    id: string | null;
    name: string;
    tab: 'schema' | undefined;
   } | null>(null);

  const handleCloseDetails = () => {
    setSelected({
      id: null,
      name: '',
      tab: 'schema'
    });
  };

  const handleViewSchemas = (connectionId: string, connectionName: string) => {
    setSelected({
      id: connectionId,
      name: connectionName,
      tab: 'schema'
    });
  };

  return selected?.id ? (
    <ConnectionDetailsPage
      initiativeId={initiativeId}
      connectionId={selected.id}
      connectionName={selected.name}
      onClose={handleCloseDetails}
      initialTab={selected.tab}
    />
  ) : (
    <DataConnections
      initiativeId={initiativeId}
      handleViewSchemas={handleViewSchemas}
    />
  );
};
